import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import {
  withDefaults,
  computed,
  TableHTMLAttributes,
  useAttrs,
  provide,
} from "vue";

export type ProvideTable = {
  dark: boolean;
  bordered: boolean;
  hover: boolean;
  striped: boolean;
  sm: boolean;
};

interface TableProps extends TableHTMLAttributes {
  dark?: boolean;
  bordered?: boolean;
  hover?: boolean;
  striped?: boolean;
  sm?: boolean;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Table',
  props: {
    dark: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    sm: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { dark, bordered, hover, striped, sm } = __props as { dark: boolean, bordered: boolean, hover: boolean, striped: boolean, sm: boolean }



const attrs = useAttrs();

const computedClass = computed(() =>
  twMerge([
    "w-full text-left",
    dark && "bg-dark text-white dark:bg-black/30",
    typeof attrs.class === "string" && attrs.class,
  ])
);

provide<ProvideTable>("table", {
  dark: dark,
  bordered: bordered,
  hover: hover,
  striped: striped,
  sm: sm,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})